// extracted by mini-css-extract-plugin
export var card = "_ak-1";
export var container = "_ak-0";